import axios from '../../../build/http-requests/axios-common'

export default {
  state: {
    situationFilter: {
      arraySituations: [],
      type: null,
      dateFirstDue: null,
      fromDashboard: false
    }
  },

  mutations: {
    SET_FILTER_TASK_LIST (state, filter) {
      state.situationFilter = {
        arraySituations: filter.arraySituations,
        type: filter.type,
        dateFirstDue: filter.dateFirstDue,
        fromDashboard: filter.fromDashboard
      }
    },

    CLEAR_FILTER_TASK_LIST (state, filter) {
      state.situationFilter = {
        arraySituations: [],
        type: null,
        dateFirstDue: null
      }
    }
  },

  actions: {
    searchAssignment: ({ commit }, filter) => {
      return new Promise((resolve, reject) => {
        axios.post('/assignment/', filter).then(response => {
          resolve(response)
        }).catch((error) => {
          reject(error)
        })
      })
    },

    searchTaskBoundType: ({ commit }, tarefaId) => {
      return new Promise((resolve, reject) => {
        axios.post('/assignment/searchTaskBoundType', {tarefaId: tarefaId}).then(response => {
          resolve(response)
        }).catch((error) => {
          reject(error)
        })
      })
    },

    setFilterTasksList: ({ commit }, filter) => {
      return new Promise((resolve, reject) => {
        commit('SET_FILTER_TASK_LIST', filter)
        resolve()
      })
    },

    clearFilterTaskList: ({ commit }) => {
      return new Promise((resolve, reject) => {
        commit('CLEAR_FILTER_TASK_LIST')
        resolve()
      })
    }
  },

  getters: {
    situationFilter: state => state.situationFilter
  }
}



// WEBPACK FOOTER //
// ./client/store/modules/assignment.js